export const captalize = (input: string): string => {
  if (input === null || input === undefined) {
    return ''
  }

  let words = input.toLowerCase().split('_')
  if (words.length <= 0) {
    words = input.split(' ')
  }

  const output = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')

  return output
}
